import service from './axios';
export const getDaycareProjects = (params = {}) => service.get('/manage/daycare-projects', { params });
export const getDaycareProject = (id) => service.get(`/manage/daycare-projects/${id}`);
export const createDaycareProject = (d) => service.post('/manage/daycare-projects', d);
export const updateDaycareProject = (id, d) => service.put(`/manage/daycare-projects/${id}`, d);
export const deleteDaycareProject = (id) => service.delete(`/manage/daycare-projects/${id}`);
